import { useEffect, useState } from 'react';
import { matchAcronyms } from '../../logic/utils/utils';
import { getMatchData } from '../../backend/entryPoints/getMatchDataFromServer';
import { calculateStanding } from '../../logic/standing/calculateStanding';
import GameScoreModel from '../gameScoreModel/GameScoreModel';
import { MatchViewModelSchema } from '../../backend/entryPoints/mapper/mapToMatchViewModel';

import './standing.css';

function Standing() {
    const [homeTeam, setHomeTeam] = useState('Home');
    const [guestTeam, setGuestTeam] = useState('Guest');
    const [points, setPoints] = useState<number[]>([0, 0]);

    useEffect(() => {
        setInterval(async () => {
            const matchesPromise = await Promise.all(
                matchAcronyms.map(async (match) =>
                    getMatchData(match).then((response) => response.text().then((data) => mapToMatchViewModel(data)))
                )
            );
            setHomeTeam(matchesPromise[0].home_team);
            setGuestTeam(matchesPromise[0].guest_team);

            setPoints(calculateStanding(matchesPromise));
        }, 10000);
    }, []);

    const mapToMatchViewModel = (data: string) => {
        return MatchViewModelSchema.parse(JSON.parse(data));
    };

    return (
        <>
            <title>BCT - Standing</title>
            <div className={'center-container'}>
                <div className={'standing-container'}>
                    <span className={'span-standing'}>{homeTeam}</span>
                    <span className={'span-standing'}>{points[0]}</span>
                    <span className={'span-standing'}>:</span>
                    <span className={'span-standing'}>{points[1]}</span>
                    <span className={'span-standing'}>{guestTeam}</span>
                </div>
                <div className={'center-container'}>
                    <GameScoreModel side={'left'} />
                </div>
                <div className={'center-container'}>
                    <GameScoreModel side={'right'} />
                </div>
            </div>
        </>
    );
}

export default Standing;
